module.exports = __webpack_public_path__ + "img/zip.73722f5f.svg";